import {
  Box,
  LinkBox,
  LinkOverlay,
  SimpleGrid,
  Tooltip,
  Text,
} from '@chakra-ui/react'
import { FC } from 'react'
import { IMeshData, IModelDesignData } from '../../../../../type/designType'
import { IColor, IMesh, IVariant } from '../../../../../type/modelType'
import { changeColorByMeshName } from '../../../../../utils/design/customization'

interface IProps {
  mesh: IMesh
  designData: IModelDesignData
  setMeshData: (meshData: IMeshData) => void
}

const fieldSetStyle = {
  padding: 0,
  paddingBlock: '15px',
  borderTop: '1px solid #E2E8F0',
}

const legendStyle = {
  paddingRight: '15px',
}

export const ColorPanel: FC<IProps> = ({ mesh, designData, setMeshData }) => {
  const { colors, variants } = mesh
  const variantsMeshName = variants.map(variant => variant.meshName)
  const meshData = designData.modelConfig.meshes.find(
    m => mesh.id === m.id
  ) as IMeshData

  return (
    <Box>
      <fieldset style={fieldSetStyle}>
        <legend style={legendStyle}>Color</legend>
        <SimpleGrid columns={4} spacing="3">
          {colors
            ?.filter(c => c.isOption)
            .map(color => (
              <Tooltip
                key={`mesh-${mesh.id}-color-panel-${color.id}`}
                label={color.hex}
                hasArrow
              >
                <LinkBox as="div" className="material-option-box">
                  <LinkOverlay
                    onClick={() => {
                      changeColorByMeshName(color, variantsMeshName)
                      delete meshData.textures
                      setMeshData({
                        ...meshData,
                        colors: [
                          {
                            id: color.id,
                          },
                        ],
                      })
                    }}
                  >
                    <Box
                      w="50px"
                      h="50px"
                      bg={color.hex}
                      borderColor="#000000"
                      borderRadius="full"
                      shadow="md"
                      cursor="pointer"
                      margin="auto"
                    ></Box>
                  </LinkOverlay>

                  <Text textAlign="center">{color.title}</Text>
                </LinkBox>
              </Tooltip>
            ))}
        </SimpleGrid>
      </fieldset>
    </Box>
  )
}
